import { RootState } from '@/store/types';
import { AxiosCacheInstance, setupCache } from 'axios-cache-interceptor';
import Vue from 'vue';
import { Store } from 'vuex';
import { addRequestInterceptors } from './http-interceptors-global';
import axios from 'axios';

declare module 'vue/types/vue' {

  interface Vue {
    $api: AxiosCacheInstance,
    $inMemoryEventsHub: Vue // Used as Message Bus
  }

  interface VueConstructor {
    $api: AxiosCacheInstance
  }
}

export function ApiAxios(vueCtor: typeof Vue, store: Store<RootState>): void {
  const axiosInstance = axios.create({
    baseURL: vueCtor.$settings.apiUrl,
  })

  const api = setupCache(axiosInstance, {
    ttl: 15 * 60 * 1000,
    cachePredicate: {
      // No cache by default
      statusCheck: () => false
    },
  })

  addRequestInterceptors(api, store)

  vueCtor.prototype.$api = api
}
